/* eslint-disable no-constant-condition */
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import intl from "react-intl-universal"
import { toast } from "@stardust-ds/react"
import FileIcon from "../../../../../assets/icons/CIQIcon"
import ContentBlank from "../../../../molecules/ContentBlank"
import RcmpHeader from "../../../../atoms/Header"
import DateFilter from "./components/dateFilter"
import MaxImprecision from "./components/maxImprecision"
import LevelCards from "./components/levelCards"
import {
  equipmentAnalyteLaunchDetails,
  equipmentAnalyteLaunchRuns,
} from "../../../../../services/ciq"
import styles from "./index.module.scss"
import useDataApi from "../../../../../hooks/useDataApi"
import RcmpLoading from "../../../../atoms/Loading"
import TableFormLaunchs from "./components/tableFormLaunchs"
import DataLaunchs from "./components/dataLaunchs"
import { fnCanAtLeast } from "../../../../../utils/permissions"
import { useNavigate } from "react-router-dom"
import { listHistoryLaunched } from "../../../../../services/ciq"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import { useContext } from "react"
import { AuthContext } from "../../../../../contexts/Auth"
import ModalComponent from "../../components/ModalComponent"
import { HistoryComponent } from "../../components/HistoryComponent"
import {
  fnisOnlyPermition,
  fnIsAccessPermition,
} from "../../../../../utils/verifyPermitions"

const ReleaseDetail = () => {
  const { equipmentId, analyteId } = useParams()
  const [abreadCrumbs, setABreadCrumbs] = useState()
  const [oReleaseDetailsRes, fnReleaseDetailsReq] = useDataApi(
    equipmentAnalyteLaunchDetails,
  )
  const [dataHistory, setDataHistory] = useState([])
  const [isLoadHistory, setIsLoadHistory] = useState(false)
  const [oRunsRes, fnRunsReq] = useDataApi(equipmentAnalyteLaunchRuns)
  const navigate = useNavigate()
  const [bIsHistoryOpenModal, setBIsHistoryOpenModal] = useState(false)
  const [infoInfinitScroll, setInfoInfinitScroll] = useState({})
  const [perPage, setperPage] = useState(1)
  const [text_type, setTextType] = useState("")
  const [searchType, setSearchType] = useState("")

  const oAnalyte = oReleaseDetailsRes?.data?.data?.equipment_analyte
  const nEquipmentAnalyteId = oAnalyte?.eqpanlt_nid
  const oDataRuns = oRunsRes?.data?.data || null
  const runs = oDataRuns?.data || []

  const { oUser } = useContext(AuthContext)

  const cUserTimeZone = oUser?.data?.user_ctimezone

  useEffect(() => {
    if (!equipmentId || !analyteId) return
    ;(async () => {
      const response = await fetchReleaseDetails()
      setABreadCrumbs([
        {
          path: "./",
          name: intl.get("home"),
        },
        {
          path: "/ciq",
          name: intl.get("ciq.title"),
        },
        {
          path: `/ciq/release/${equipmentId}`,
          name: response?.data?.equipment_cname,
        },
        {
          name: response?.data?.equipment_analyte?.anlt_cname,
          bActive: true,
        },
      ])
    })()

    fetchRuns()
  }, [equipmentId, analyteId])

  const fetchReleaseDetails = async () => {
    if (oReleaseDetailsRes.loading) return
    return await fnReleaseDetailsReq(equipmentId, analyteId)
  }

  const fetchRuns = async (nPage = 1, startDate = null, endDate = null) => {
    const period = JSON.parse(localStorage.getItem("datePeriod"))

    const strtdate = new Date(period?.startDate + "T00:00:00")
    const endDte = new Date(period?.endDate + "T00:00:00")

    if (endDte < strtdate) {
      await fnRunsReq(equipmentId, analyteId, nPage, 10, startDate, endDate)
      return
    }

    if (period) {
      await fnRunsReq(equipmentId, analyteId, nPage, 10, period.startDate, period.endDate)
      return
    }
    await fnRunsReq(equipmentId, analyteId, nPage, 10, startDate, endDate)
  }

  const getHistoricLaunchs = async (id, perPage, searchType, textType, subtarget_nid) => {
    try {
      setDataHistory([])
      setIsLoadHistory(true)
      const { data: dt } = await listHistoryLaunched(
        id,
        perPage,
        searchType,
        textType,
        subtarget_nid,
      )

      const newDataHistory = dt.data.data.map((item) => {
        const [data, hour] = fnFormatDateFromUTC(
          item.history_dupdated,
          "DD/MM/YYYY - HH:mm",
          cUserTimeZone,
        ).split(" - ")

        return {
          ...item,
          history_caction: item.history_caction,
          history_data: data,
          history_hour: hour,
          history_user_cname: item.history_user?.cname,
        }
      })

      setDataHistory(newDataHistory)

      setInfoInfinitScroll({
        last_page: dt.data.last_page,
        next_page_url: dt.data.next_page_url,
        data_length: dt.data.data.length,
      })
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadHistory(false)
    }
  }

  useEffect(() => {
    if (!oReleaseDetailsRes.done || !oReleaseDetailsRes.error) return

    toast({
      type: "error",
      description: intl.get("ciq.release_details.error_to_load"),
    })
  }, [oReleaseDetailsRes])

  useEffect(() => {
    if (!oRunsRes.done || !oRunsRes.error) return

    toast({
      type: "error",
      description: intl.get("ciq.release_details.runs_error_to_load"),
    })
  }, [oRunsRes])

  const onChangeDateFilter = async (dates) => {
    await fetchRuns(1, dates?.startDate, dates?.endDate)
  }

  const fetchHistory = async () => {
    if (!equipmentId || !nEquipmentAnalyteId || isLoadHistory) return

    await getHistoricLaunchs(
      equipmentId,
      perPage,
      searchType,
      text_type,
      nEquipmentAnalyteId,
    )
  }

  const fetchRunsAndHistory = async (nPage = 1, startDate = null, endDate = null) => {
    Promise.all([
      fetchRuns(nPage, startDate, endDate),
      fetchHistory(),
      fetchReleaseDetails(),
    ])
  }

  const isAccessCreateEditLaunchn = fnIsAccessPermition("create-edit-launch")
  const isOnlyView = !isAccessCreateEditLaunchn
  const isPermition = fnisOnlyPermition("access-ciq") || isOnlyView

  useEffect(() => {
    if (isPermition) {
      return
    } else if (!fnCanAtLeast("create-edit-launch", "internal-quality-control")) {
      if (
        !fnCanAtLeast("access-ciq", "internal-quality-control") ||
        !fnCanAtLeast("create-edit-launch", "internal-quality-control")
      ) {
        window.location.href = "/"
        return
      } else if (
        fnCanAtLeast("create-edit-equipment", "internal-quality-control") ||
        fnCanAtLeast("create-edit-control", "internal-quality-control") ||
        (fnCanAtLeast("update-run", "internal-quality-control") &&
          !fnCanAtLeast("create-edit-launch", "internal-quality-control"))
      ) {
        window.location.href = "/"
        return
      }
    }
  }, [])

  useEffect(() => {
    if (!cUserTimeZone) return
    fetchHistory()
  }, [equipmentId, perPage, text_type, oReleaseDetailsRes, nEquipmentAnalyteId, cUserTimeZone])

  return (
    <div>
      <RcmpHeader
        elIcon={<FileIcon />}
        cTitlePage={intl.get("ciq.internal_control_quality")}
        aBreadCrumbs={abreadCrumbs}
        className={styles.header}
      ></RcmpHeader>
      <ContentBlank
        bShowFilter={false}
        bCanSearch={false}
        bSwitchable={false}
        bVisibleIconSearch={false}
        bArrowLeftGoBack={true}
        cPathGoBack={`/ciq/release/${equipmentId}`}
        cLabelGoBack={oAnalyte?.anlt_cname}
        className={styles.customHeader}
        bShowHistory
        fnHandleOpenModal={() => setBIsHistoryOpenModal(true)}
        elHeaderChildren={
          <DateFilter
            justify="flex-end"
            nameFilter="datePeriod"
            onChangeDate={onChangeDateFilter}
            anlt_cname={oAnalyte?.anlt_cname}
          />
        }
      >
        {bIsHistoryOpenModal && (
          <ModalComponent
            title={intl.get("ciq.equipment_history")}
            fnCloseModal={() => setBIsHistoryOpenModal(false)}
            size="xlg"
          >
            <HistoryComponent
              searchHistory="equipment"
              history={dataHistory}
              infoInfinitScroll={infoInfinitScroll}
              setPerPage={setperPage}
              perPage={perPage}
              isLoadHistory={isLoadHistory}
              setSearchType={setSearchType}
              setSearchText={setTextType}
            />
          </ModalComponent>
        )}
        <RcmpLoading bShow={oReleaseDetailsRes.loading} size={50} />
        <div className={styles.pageContainer}>
          <MaxImprecision oAnalyte={oAnalyte} />
          <LevelCards oAnalyte={oAnalyte} fetchReleaseDetails={fetchReleaseDetails} />

          <RcmpLoading
            bShow={!oReleaseDetailsRes.loading && oRunsRes.loading}
            size={50}
          />
          {!oRunsRes.loading && (
            <>
              <TableFormLaunchs
                oAnalyte={oAnalyte}
                oDataRuns={oDataRuns}
                fetchRuns={fetchRuns}
                fetchRunsAndHistory={fetchRunsAndHistory}
              />
              <DataLaunchs oAnalyte={oAnalyte} runs={runs} />
            </>
          )}
        </div>
      </ContentBlank>
    </div>
  )
}

export default ReleaseDetail
